export const symbolsWithNumbers = text => {
  let formattedText = text
  formattedText = text.split(' ')
  let numberCounter = 0
  const asdww = formattedText.map(word=>{
    return word.split('')
  })
  
  const readyText = asdww.map(word=>{
    const tttt = word.map(symbol=>{
      const isNumberCheck = Number(symbol)
      if(isNaN(isNumberCheck)) {
        return symbol
      } else {
        numberCounter= ++numberCounter
        return 'aiaiai'
      }
    })
    return tttt
  })

  readyText.forEach(array=>{
    let wordsCount = 0
    for(let i = 0; i<array.length; i++){
      if (array[i]!=='aiaiai'&& array.find(symbol=>symbol!=='aiaiai') && wordsCount === 0) {
        numberCounter = ++numberCounter
        wordsCount = 1
      } else if (array[i] !== 'aiaiai'&& array[i-1]==='aiaiai') {
        numberCounter = ++numberCounter
        // isChecked = true
      }
    }
  })
  const finalText = readyText.map(array=>array.join('')).join('')
    
    return {length: finalText.length, wordCounter: numberCounter}
  }